export enum CONTEXT {
    KITCHEN = "kitchen",
    STORAGE = "storage",
    BATHROOM = "bathroom"
}